<template>

</template>

<script>


import {mapGetters} from "vuex";


export default {
    middleware: "auth",

    computed: {
        ...mapGetters({
            user: "auth/user",
        }),
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/backoffice/lending-point/detail.vue